import { SkeletonArrayValues } from '../../../typings/skeleton';

export const setSkeletonArrayOrValue = (name: string, value: string | SkeletonArrayValues): object =>
  Array.isArray(value) ? setSkeletonCSSVars(name, value) : { [name]: value };

export const setSkeletonCSSVars = (name: string, value: SkeletonArrayValues) => {
  const mobileCssVar = `--skeleton-${name}-mobile`;
  const tabletCssVar = `--skeleton-${name}-tablet`;
  const desktopCssVar = `--skeleton-${name}-desktop`;

  switch (value.length) {
    case 2:
      return {
        [mobileCssVar]: value[0],
        [tabletCssVar]: value[0],
        [desktopCssVar]: value[1],
      };

    case 3:
      return {
        [mobileCssVar]: value[0],
        [tabletCssVar]: value[1],
        [desktopCssVar]: value[2],
      };

    /* istanbul ignore next: unreachable code */
    default:
      return {};
  }
};
